import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import { getWorkspaceId } from "./workspaceStorage";

/* Helper to subscribe t an websocket */
const Websocket = () => {

    const subscribe = ({ socket, action }) => {
        const mainURL =window?.RUNTIME_CONFIG?.BACKEND_URL || "http://localhost:8080";
        const workspaceId = getWorkspaceId();

        const stompClient = new Client({
            webSocketFactory: () => new SockJS(`${mainURL}/ws`),
            reconnectDelay: 5000,
            onConnect: () => {
                stompClient.subscribe(`/topic/${workspaceId}/${socket}`, (msg) => {
                    action(msg)
                });
            }
        });

        stompClient.activate();

        return () => {
            stompClient.deactivate();
        };
    }

    return {
        subscribe
    }
}

export default Websocket